// services/OfflineManager.js
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';
import { createLogger } from '../services/Debug';
export class OfflineManager {
  constructor() {
    this.isOnline = navigator.onLine;
    this.listeners = new Set();
    
    // Initialize network monitoring
    this.initNetworkMonitoring();
  }

  initNetworkMonitoring() {
    // Check if running on Capacitor
    const isCapacitorPlatform = Capacitor.isNativePlatform();
    
    if (isCapacitorPlatform) {
      // Capacitor network monitoring
      Network.addListener('networkStatusChange', (status) => {
        this.handleNetworkChange(status.connected);
      });
      
      // Initial check
      Network.getStatus().then(status => {
        this.isOnline = status.connected;
      }).catch(err => {
        const log = createLogger('OfflineManager');
        log.warn('Failed to get network status:', err);
      });
    } else {
      // Web network monitoring
      window.addEventListener('online', () => this.handleNetworkChange(true));
      window.addEventListener('offline', () => this.handleNetworkChange(false));
    }
  }

  handleNetworkChange(isOnline) {
    const wasOffline = !this.isOnline;
    this.isOnline = isOnline;
    
    // Notify all listeners
    this.listeners.forEach(listener => listener(isOnline));

  }

  // Add listener for network changes
  addNetworkListener(callback) {
    this.listeners.add(callback);
    // Immediately call with current status
    callback(this.isOnline);
    return () => this.listeners.delete(callback);
  }

  // Check if we're online
  getIsOnline() {
    return this.isOnline;
  }

  // For backward compatibility - always return false/empty
  hasOfflineData() {
    return false;
  }

  // For backward compatibility - always return zeros
  getOfflineDataCount() {
    return {
      pendingRequests: 0,
      offlineAudio: 0
    };
  }
}

// Create singleton instance
export const offlineManager = new OfflineManager();